import { render, staticRenderFns } from "./DataTableNew.vue?vue&type=template&id=0d7cc873"
import script from "./DataTableNew.vue?vue&type=script&lang=js"
export * from "./DataTableNew.vue?vue&type=script&lang=js"
import style0 from "./DataTableNew.vue?vue&type=style&index=0&id=0d7cc873&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports